import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import PageHeader from 'components/PageHeader'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useFlag from 'hooks/useFlag'
import { useOrderingAccess } from 'hooks/useOrderingAccess'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import Helmet from 'react-helmet'
import { I18n } from 'react-redux-i18n'
import { Redirect } from 'react-router-dom'
import LookerFooter from 'scenes/LookerEmbed/components/LookerFooter'
import LookerIframe from 'scenes/LookerEmbed/LookerIframe'

const t = buildTranslate('looker')

/**
 * Ordering Error Report. Surfaces the Unaccepted Carts dashboard as a
 * standalone operator-focused report under the Operations Center nav.
 * Previously the Unaccepted Carts dashboard was a second tab on the
 * Cart Conversion page (`/reports/ordering_conversion`).
 */
const OrderingErrorReport = () => {
  const operationsCenterEnabled = useFlag('operations-center', false)
  const merchant = useCurrentMerchant()
  const [css] = useStyletron()
  const { supportsOrderingProvider } = useOrderingAccess()

  if (!operationsCenterEnabled) return <Redirect to="/" />
  if (!merchant) return null

  const title = I18n.t('nav.operations_center_menu.ordering_error_report')
  const unacceptedHeight = 2500

  return (
    <PageHeader title={title}>
      <Helmet>
        <title>{I18n.t(`titles./reports/ordering_error_report`)}</title>
      </Helmet>
      <Switch
        condition={supportsOrderingProvider}
        fallback={
          <Container className="pb-l h-100 grey-05-bkg">
            <Text.Header4 bold color="grey90" className="text-center">
              {t('olo_toast_only')}
            </Text.Header4>
          </Container>
        }
      >
        <Container
          className={`px-0 pb-l h-100 grey-05-bkg ${css({
            minHeight: `${unacceptedHeight + 300}px`,
          })}`}
        >
          <LookerIframe
            path={'dashboards/215'}
            merchant={merchant}
            height={`${unacceptedHeight}px`}
          />
          <LookerFooter className="my-xl" />
        </Container>
      </Switch>
    </PageHeader>
  )
}

export default OrderingErrorReport
